import LabelModal from './LabelModal';

export default LabelModal;
